module.exports = {
      id: "illustrations:NZ02-usage",
      viewBox: "0 0 476.2 330",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#illustrations:NZ02-usage",
      toString: function () {
        return this.url;
      }
    }